import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { RootPage } from "./pages/Root.js";
import { DiaryDetailPage } from "./pages/DiaryDetail.js";
import { DiaryListPage } from "./pages/DiaryList.js";

function Header() {
  return (
    <header>
      <div className="container">
        <h1>iwashi-station</h1>
        <p>森野いわし</p>
      </div>
    </header>
  );
}


function Image(props) {
  return (
    <div className="card">
      <div className="card-image">
        <figure className="image">
          <img src={props.src} alt="cute image!" />
        </figure>
      </div>
    </div>
  );
}

function Gallery(props) {
  const { urls } = props;
  return (
    <div>
      {urls.map((url) => {
        return (
          <div key={url}>
            <Image src={url} />
          </div>
        );
      })}
    </div>
  );
}


function Main() {
  const urls = [
    "./images/setsubun_iwashi.png"
  ];
  
  return (
    <main>
      <Router>
        <Switch>
        <section className="section">
        <div className="container">

          <Route path="/" exact>
            <Gallery urls={urls} />
            <RootPage />
          </Route>

          <Route path="/diaries" exact>
            <DiaryListPage />
          </Route>

          <Route path="/diaries/:diaryId">
            <DiaryDetailPage />
          </Route>

        </div>
        </section>
        </Switch>
      </Router>
    </main>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <p>piyo works 2021</p>
    </footer>
  );
}

function App() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
